
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import Landing from './pages/landing';
import Signin from './pages/signin';
import Auth from './pages/auth';
import Otp from './components/otp';

import reportWebVitals from './reportWebVitals';

import { Route, Routes, BrowserRouter as Router, } from 'react-router-dom';
import './fonts/Helvetica-Font/Helvetica.ttf';
import CreatePassword from './components/createPassword';
import ProfileName from './components/setProfileName';
import Dashboard from './pages/dashboard';
import NotFound from './pages/notFound';

import { loadProgressBar } from 'axios-progress-bar';
import 'axios-progress-bar/dist/nprogress.css';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from '@stripe/react-stripe-js';
import { PrivacyPolicy } from './privacyPolicy';
import { Box } from '@mui/material';
import wa_ic from './images/whatsapp.svg';



loadProgressBar();


// Production (accordcalling.com)
export const BASE_URL_VOIPSWITCH = "https://backend.nativetalkapp.com:449/VS.WebAPI.Admin/"
export const BASE_URL_VOIPSWITCH2 = "https://backend.nativetalkapp.com:449/vsservices/api/json/syncreply/"
export const BACKEND = "https://backend.nativetalkapp.com:453/"
export const EMAILAPP = "https://crm.nativetalkapp.com:447/flsk/"

export const ENDPOINTS = { 
  // Voipswitch
  'login': 'admin.client.login',
  'editProfile': 'admin.client.personal.update',
  'changePassword': 'admin.client.password.set',
  'getPassword': 'admin.client.password.get',
  'signup': 'admin.retail.create',
  'getBalance': 'admin.client.balance',
  'getPlansList': 'admin.plans.list',
  'getPlanData': 'admin.plan.get',
  'addPlan': 'admin.client.plan.add',
  'addFunds': 'admin.payment.add',
  'setDid': 'admin.client.techprefix.set',
  'getNumberList': 'admin.did.local.number.list',
  'getClientInfo': 'json/syncreply/admin.client.personal.get',
  'getClientPlanList': 'admin.client.plan.list',
  'getPlanDetails': 'admin.plan.get',
  'getTechPrefix': 'admin.client.techprefix.get',

  // Voipswitch 2
  'buyNumber': 'client.dids.numbers.buy',
  'getClientDid': 'client.dids.numbers.get',  

  // emailing
  'accordMail': 'ac-mail',

  // Nativetalk multipurpose backend
  'sendNigerianOtp': 'otp',
  'cancelSubscription': 'cancel-subscription',
  'createStripeCustomer': 'stripe-customers',
  'createStripeSubscription': 'stripe-subscriptions',
  'getStripeSecret': 'create-stripe-payment-intent',
}

// Automatically bill monthly
// Small button


// const stripePromise = loadStripe('pk_test_51MoPGeKrQZChVQKPohGpEkpDkaBcid2LTapaUm6WdiyPYlJooAQg7vCdGwQW8EmbqAguXSkPREoDKPTt8OoFz51k00MBpPkKxU')
const stripePromise = loadStripe('pk_live_51MoPGeKrQZChVQKPk2WzF1gpvRuIZHAKnYH6BJmFtIrcVjorxplzG6EqKsJb20EheZQT37Pd59XfxsRaUCu4LwnF00wYroHPvi')


class App extends React.Component {
  render() {
    return (
      
      <Router>
        <div>
        
          <Routes>
            <Route path='/' element={<Landing />}></Route>
            <Route path='/Signin' element={<Signin />}></Route>
            <Route path='/Otp' element={<Otp />}></Route>
            <Route path='/CreatePassword' element={<CreatePassword />}></Route>
            <Route path='/ProfileName' element={<ProfileName />}></Route>
            <Route path='/Auth' element={<Auth />}></Route>
            <Route path='/Dashboard' element={<Dashboard />}></Route>
          
            <Route exact path='/PrivacyPolicy' element={<PrivacyPolicy />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
          <a href="https://wa.me/+16075275847">
            <Box component='img' width={50} sx={{
              zIndex: '1500', bottom: '10px', right: '50px'
            }} position='fixed' src={wa_ic} />
          </a>
        </div>
      </Router>
      
    )
  }  
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Elements stripe={stripePromise}>
    <App />
  </Elements>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
